import { Component, ElementRef, TemplateRef, ContentChildren } from '@angular/core';
import { ToastrConfig, ToastrService, Toast, ToastData, ToastRef } from 'ngx-toastr';
import * as _ from 'lodash';
import { AlertModel } from '../../models/alert/alert.model';
import { AlertStylingModel } from '../../models/alert/alert-styling.model';
import { CfCoreComponent } from '../core/core.component';
import { CfAlertComponent } from '../alert/alert.component';
import { AlertTemplates } from '../../templates/alert.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>Alerts component is based on <a href="https://github.com/scttcper/ngx-toastr" target="_blank">Ngx-toastr</a></p>
 * <p>Example of using:</p>
 * <pre>
 * <code><</code>cf-alerts #myAlerts<code>></code><code><</code><code>/</code>cf-alerts<code>></code>
 * </pre>
 */
export class CfAlertsComponent extends CfCoreComponent {
/**
 * @hidden 
 * Object of type ToastrConfig to be used in ToastrService
 */
options: ToastrConfig;
/**
 * @hidden 
 * Array for aech alert ID
 */
private lastInserted: number[] = [];
/**
 * @hidden
 */
cfAlertsTemplates;
/**
 * @hidden 
 * Registering toastrService based on core ToastrService
 * @param {?} toastrService
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public toastrService: ToastrService,
public elementRef: ElementRef,
                /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.options = this.toastrService.toastrConfig;
  }
/**
 * @hidden 
 * Function to show alerts based on given type
 * @param {?} props
 * @param {?} styles
 * @return {?}
 */
ngxToastrShow(props, styles): any {
    let /** @type {?} */ opt = _.cloneDeep(this.options);
    opt = Object.assign(opt, props, { 'styling': styles });
    opt.toastClass = 'cf-alert';
    opt.toastComponent = CfAlertComponent;
    const /** @type {?} */ inserted = this.toastrService.show(null, null, opt);
    if (inserted) { this.lastInserted.push(inserted.toastId); }
    return inserted;
  }
/**
 * @hidden 
 * Function to generate alert template, properties and styling based on type (info, warning, error)
 * @param {?} props
 * @param {?} styles
 * @param {?} type
 * @return {?}
 */
generateNewAlert(props, styles, type) {
    // check if custom html template is specified
    if (props && props.content && props.content.templateName !== '') {
      this.cfAlertsTemplates._results.forEach((tmpl, index) => {
        let /** @type {?} */ tmplKey = Object.keys(tmpl._def.references)[0];
        if (props.content.templateName === tmplKey) { props.templateRef = tmpl; }
      });
    }
    // check for default component template
    switch (type) {
      case 'warning':
        this.compTemplate = (props && props.compTemplate) ? props.compTemplate : 'default/alert-warning-template';
        if (props) { props['type'] = 'warning'; }
        break;
      case 'error':
        this.compTemplate = (props && props.compTemplate) ? props.compTemplate : 'default/alert-error-template';
        if (props) { props['type'] = 'error'; }
        break;
      default:
        this.compTemplate = (props && props.compTemplate) ? props.compTemplate : 'default/alert-template';
        if (props) { props['type'] = 'info'; }
        break;
    }
    // check for custom component template
    if (props && props.compTemplate) { this.compTemplate = props.compTemplate; }
    // generating alert properties and styling objects
    this.getMyTemplate('alert', AlertTemplates).then(() => {
      if (props == null) {
        props = new AlertModel(this.activeTemplate['property']);
      } else {
        let /** @type {?} */ mainKeys = Object.keys(this.activeTemplate['property']);
        for (let /** @type {?} */ key of mainKeys) {
          if (props[key] == null) { props[key] = this.activeTemplate['property'][key]; }
        }
      }
      if (props.position !== '') { props.positionClass = props.position; }
      if (styles == null) { styles = new AlertStylingModel(this.activeTemplate['styling']); }
      this.ngxToastrShow(props, styles);
    });
  }
/**
 * Function to show info alert
 * @param {?} props 		alert properties model object
 * @param {?} styles 		alert styling model object
 * @return {?}
 */
showMessage(props, styles) { this.generateNewAlert(props, styles, 'info'); }
/**
 * Function to show warning alert
 * @param {?} props 		alert properties model object
 * @param {?} styles 		alert styling model object
 * @return {?}
 */
showWarning(props, styles) { this.generateNewAlert(props, styles, 'warning'); }
/**
 * Function to show error alert
 * @param {?} props 		alert properties model object
 * @param {?} styles 		alert styling model object
 * @return {?}
 */
showError(props, styles) { this.generateNewAlert(props, styles, 'error'); }
/**
 * Function to clear all alerts
 * @return {?}
 */
clearAll() { this.toastrService.clear(); }
/**
 * Function to delete last alert
 * @return {?}
 */
clearLast() { this.toastrService.clear(this.lastInserted.pop()); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-alerts',
  template: "",
  styles: ["/deep/ #toast-container { pointer-events: none; position: fixed; z-index: 800000; display: flex; flex-direction: column; } /deep/ .top-left, /deep/ .toast-top-left { top: 0px; left: 0px; } /deep/ .top-left > cf-alert, /deep/ .toast-top-left > cf-alert { margin-top: 8px; } /deep/ .top-right, /deep/ .toast-top-right { top: 0px; right: 0px; } /deep/ .top-right > cf-alert, /deep/ .toast-top-right > cf-alert { margin-top: 8px; } /deep/ .bottom-right, /deep/ .toast-bottom-right { right: 0px; bottom: 0px; } /deep/ .bottom-right > cf-alert, /deep/ .toast-bottom-right > cf-alert { margin-bottom: 8px; } /deep/ .bottom-left, /deep/ .toast-bottom-left { bottom: 0px; left: 0px; } /deep/ .bottom-left > cf-alert, /deep/ .toast-bottom-left > cf-alert { margin-bottom: 8px; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ToastrService, },
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cfAlertsTemplates': [{ type: ContentChildren, args: [TemplateRef, ] },],
};
}

function CfAlertsComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertsComponent.ctorParameters;
/** @type {?} */
CfAlertsComponent.propDecorators;
/**
 * @hidden 
 * Object of type ToastrConfig to be used in ToastrService
 * @type {?}
 */
CfAlertsComponent.prototype.options;
/**
 * @hidden 
 * Array for aech alert ID
 * @type {?}
 */
CfAlertsComponent.prototype.lastInserted;
/**
 * @hidden
 * @type {?}
 */
CfAlertsComponent.prototype.cfAlertsTemplates;
/**
 * @hidden
 * @type {?}
 */
CfAlertsComponent.prototype.toastrService;
/**
 * @hidden
 * @type {?}
 */
CfAlertsComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
